<template>
  <div v-if="currentTraining != null">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-solid">
          <div class="box-body">
            <div class="box-group" id="accordion">
              <div class="panel box box-primary">
                <div class="box-header with-border">
                  <h4 class="box-title">
                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseHelpFaq" aria-expanded="false"
                       class="collapsed">
                      {{$t('help.title')}}
                    </a>
                  </h4>
                </div>
                <div id="collapseHelpFaq" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                  <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                    <p>Here one can create items of «Frequently Asked Questions» for this specific Sports Program. It means that the F.A.Q. items added in this section will be applicable only to this Sports Program. Such F.A.Q. items serve as an additional information resource for potential customers. Once the item is added, one may edit, publish/unpublish or delete it if needed.</p>
                    <p>There is always a possibility to add a F.A.Q. item default/common for all Sports Programs in the section «Sports Organisation»</p>
                  </div>
                  <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                    <p>В этой секции можно создать список часто задаваемых вопросов только для данной конкретной Спортивной Программы.</p>
                    <p>Добавленный «вопрос» можно отредактировать, опубликовать / снять с публикации, удалить в любой момент времени.</p>
                    <p>Если нужно, всегда есть возможность добавить «вопрос», общий для всех спортивных программ, в секции Кабинета «Спортивная Организация».</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="panel box box-primary">
          <div class="box-header with-border">
            <h4 class="box-title">
              <a data-toggle="collapse" data-parent="#accordion" href="#collapseFaqCamps" aria-expanded="false"
                 class="collapsed">
                {{$t('trainings.faqs.camp-faqs')}}
              </a>
            </h4>
          </div>
          <div id="collapseFaqCamps" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
            <table v-if="!isBackoffice()" class="table table table-condensed">
              <tbody>
              <tr>
                <th width="25%">{{$t('trainings.faqs.question')}}</th>
                <th>{{$t('trainings.faqs.answer')}}</th>
                <th width="10%"></th>
              </tr>
              <tr v-for="faq in campFaqs"
                  :key="faq.id"
                  class="table table-condensed">
                <td>{{faq.question[$root.$i18n.locale]}}</td>
                <td>
                  {{getAnswer(faq.answer[$root.$i18n.locale])}}
                </td>
                <td>
                  <label>
                    <input type="checkbox" :value="faq.isPublish" disabled readonly name="isPublish" v-model="faq.isPublish">
                    {{ $t('trainings.faqs.is-publish') }}
                  </label>
                </td>
              </tr>
              </tbody>
            </table>

            <table v-if="isBackoffice()" class="table table table-condensed">
              <tbody>

              <tr>
                <th width="30"></th>
                <th width="25%">{{$t('trainings.faqs.question')}}</th>
                <th>{{$t('trainings.faqs.answer')}}</th>
                <th width="10%"></th>
              </tr>
              <tr v-for="faq in campFaqs"
                  :key="faq.id"
                  class="table table-condensed">
                <td colspan="4">
                  <table class="table" style="margin-bottom: 0">
                    <tr>
                      <td width="30">En</td>
                      <td width="25%">
                        {{faq.question['en']}}
                      </td>
                      <td>
                        {{getAnswer(faq.answer['en'])}}
                      </td>
                      <td width="10%" rowspan="2">
                        <label>
                          <input type="checkbox" :value="faq.isPublish" disabled readonly name="isPublish" v-model="faq.isPublish">
                          {{ $t('trainings.faqs.is-publish') }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Ru</td>
                      <td>{{faq.question['ru']}}</td>
                      <td>{{getAnswer(faq.answer['ru'])}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">

        <div class="box box-success">
          <div class="box-header">
            <h3 class="box-title">
              <a data-toggle="collapse" data-parent="#accordion" href="#collapseFaqs" aria-expanded="false"
                 class="collapsed">
              {{$t('trainings.faqs.active-faqs')}}
              </a>
            </h3>
          </div>
          <div id="collapseFaqs" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
            <table v-if="!isBackoffice()" class="table table table-condensed">
            <tbody>
            <tr>
              <th width="25%">{{$t('trainings.faqs.question')}}</th>
              <th>{{$t('trainings.faqs.answer')}}</th>
              <th width="10%"></th>
              <th width="10%"></th>
              <th width="10%"></th>
            </tr>
            <tr
                v-for="faq in faqs"
                :key="faq.id"
                class="table table-condensed">
              <td>{{faq.question[$root.$i18n.locale]}}</td>
              <td>
                {{getAnswer(faq.answer[$root.$i18n.locale])}}
              </td>
              <td>
                <label>
                  <input type="checkbox" :value="faq.isPublish" name="isPublish" v-model="faq.isPublish">
                  {{ $t('trainings.faqs.is-publish') }}
                </label>
              </td>
              <td style="vertical-align: middle;">
                <button type="submit" v-on:click="selectFaq(faq)" data-toggle="modal" data-target="#modal-edit-faq" class="btn btn-block btn-primary btn-xs">
                  {{ $t('trainings.faqs.edit-faq') }}
                </button>
              </td>
              <td style="vertical-align: middle;">
                <button type="submit" v-on:click="deleteFaq(faq.id)" class="btn btn-block btn-danger btn-xs">
                  {{ $t('trainings.faqs.delete-faq') }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>

            <table v-if="isBackoffice()" class="table table table-condensed">
              <tbody>
              <tr>
                <th width="30"></th>
                <th width="25%">{{$t('trainings.faqs.question')}}</th>
                <th>{{$t('trainings.faqs.answer')}}</th>
                <th width="10%"></th>
                <th width="10%"></th>
                <th width="10%"></th>
              </tr>
              <tr v-for="faq in faqs"
                  :key="faq.id"
                  class="table table-condensed">
                <td colspan="4">
                  <table class="table" style="margin-bottom: 0">
                    <tr>
                      <td width="30">En</td>
                      <td width="25%">
                        {{faq.question['en']}}
                      </td>
                      <td>
                        {{getAnswer(faq.answer['en'])}}
                      </td>
                      <td width="10%" rowspan="2">
                        <label>
                          <input type="checkbox" v-on:change="updatePublishState(faq)" :value="faq.isPublish" name="isPublish" v-model="faq.isPublish">
                          {{ $t('trainings.faqs.is-publish') }}
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td>Ru</td>
                      <td>{{faq.question['ru']}}</td>
                      <td>{{getAnswer(faq.answer['ru'])}}</td>
                    </tr>
                  </table>
                </td>
                <td style="vertical-align: middle;">
                  <button type="submit" v-on:click="selectFaq(faq)" data-toggle="modal" data-target="#modal-edit-faq" class="btn btn-block btn-primary btn-xs">
                    {{ $t('trainings.faqs.edit-faq') }}
                  </button>
                </td>
                <td style="vertical-align: middle;">
                  <button type="submit" v-on:click="deleteFaq(faq.id)" class="btn btn-block btn-danger btn-xs">
                    {{ $t('trainings.faqs.delete-faq') }}
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer">
            <button type="submit" data-toggle="modal" data-target="#modal-new-faq" class="btn btn-info pull-right">
              {{ $t('trainings.faqs.create-faq') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <SportProgramAddFaqComponent
      v-bind:sport-program="currentTraining">
    </SportProgramAddFaqComponent>

    <SportProgramEditFaqComponent
      v-bind:sport-program="currentTraining"
      v-bind:faq="currentFaq">
    </SportProgramEditFaqComponent>
  </div>
</template>

<script>
import SportProgramAddFaqComponent from './SportProgramAddFaq';
import SportProgramEditFaqComponent from './SportProgramEditFaq';
import axios from 'axios';

export default {
  name: 'TrainingFaqs',
  props: {
    currentTraining: Object
  },
  components: {
    SportProgramAddFaqComponent,
    SportProgramEditFaqComponent
  },
  data () {
    return {
      addedFaq: {
        question: {
          ru: '',
          en: ''
        },
        answer: {
          ru: '',
          en: ''
        },
        isPublish: false
      },
      faqs: [],
      currentFaq: {},
      campFaqs: [],
      campId: ''
    };
  },
  created () {
    let self = this;

    self.currentFaq = null;

    self.$root.$on('showFaqs', function (sportProgramId, campId) {
      self.campId = campId;

      axios.get(window.host + '/sport-programs/' + sportProgramId + '/faqs')
        .then(function (response) {
          console.log(response.data);
          self.faqs = response.data;
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });

      axios.get(window.host + '/sport-courses/camps/' + campId + '/faqs')
        .then(function (response) {
          self.campFaqs = response.data;
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    });
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    selectFaq: function (faq) {
      this.currentFaq = faq;
    },
    saveFaq: function () {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      console.log(self.addedFaq);

      let data = {
        question: self.addedFaq.question,
        answer: self.addedFaq.answer,
        isPublish: self.addedFaq.isPublish
      };

      axios.post(window.host + '/sport-programs/' + self.currentTraining.id + '/faqs', data)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showFaqs', self.currentTraining.id, self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    updateFaq: function (faq) {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      let data = {
        question: faq.question,
        answer: faq.answer,
        isPublish: faq.isPublish
      };

      axios.put(window.host + '/sport-programs/' + self.currentTraining.id + '/faqs/' + faq.id, data)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showFaqs', self.currentTraining.id, self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    deleteFaq: function (faqId) {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      axios.delete(window.host + '/sport-programs/' + self.currentTraining.id + '/faqs/' + faqId)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showFaqs', self.currentTraining.id, self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    getAnswer: function (str) {
      if (str.length > 100) {
        return str.substring(0, 100) + ' ...';
      }

      return str;
    },
    updatePublishState: function (faq) {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      let data = {
        question: faq.question,
        answer: faq.answer,
        isPublish: faq.isPublish
      };

      axios.put(window.host + '/sport-programs/' + self.currentTraining.id + '/faqs/' + faq.id, data)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showFaqs', self.currentTraining.id, self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
